import { useState } from 'react'
import { NumericFormat } from 'react-number-format'
import { Input, InputGroup, InputLeftAddon } from '@chakra-ui/react'
import { Controller } from 'react-hook-form'

export function InputValueBRL({ control, error }) {
  const [value, setValue] = useState(0)

  return (
    <InputGroup>
      <InputLeftAddon
        children="Outros custos"
        textTransform="uppercase"
        fontSize="14px"
        color="#1D1D1D"
        borderColor={error ? 'red.500' : '#C5CED6'}
      />

      <Controller
        name="outrosCustos"
        control={control}
        render={({ field }) => (
          <NumericFormat
            value={value} // Use a variável `value` como o valor inicial
            decimalSeparator=","
            decimalScale={2}
            fixedDecimalScale
            prefix="R$ "
            thousandSeparator="."
            customInput={Input}
            placeholder="R$ 0,00"
            borderColor={error ? 'red.500' : '#378BBF'}
            fontSize="14px"
            borderLeftRadius={0}
            {...field}
            onValueChange={(values) => {
              const { value } = values
              console.log(value)
              field.onChange(value)
            }}
          />
        )}
      />
    </InputGroup>
  )
}
